<template>
  <div class="container py-4">

    <!-- Display teacher_id and user_id -->
    <div v-if="teacherItems.length" class="mb-3">
      <h5 class="text-primary">
        Teacher ID: {{ teacherItems[0].teacher_id }} <br />
        User ID: {{ teacherItems[0].teacher?.user?.id || 'N/A' }}
      </h5>
    </div>

    <!-- Add/Update Button -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="text-dark fw-semibold">Teacher Items</h4>
      <button @click="fetchUserIdandTeacherID" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addTecherItemModal">
        <i class="bi bi-plus-circle me-1"></i> Add or Update Item
      </button>
    </div>

    <!-- Loading Spinner -->
<div v-if="loading" class="text-center my-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<!-- No Items Message -->
<div v-else-if="!teacherItems.length" class="text-center my-5">
  <h5 class="text-muted">No items found.</h5>
</div>


    <!-- Items Grid -->
    <div v-else class="row">
      <div
        v-for="(item, index) in teacherItems"
        :key="item.id"
        class="col-md-6 col-lg-4 mb-4 d-flex"
      >
        <div class="card shadow-sm w-100 position-relative item-card hover-transition">
          <!-- Delete Icon -->
          <i
            class="bi bi-trash text-danger position-absolute top-0 end-0 m-2 fs-5"
            style="cursor: pointer;"
            @click="deleteItem(item.id, index)"
            title="Delete item"
          ></i>

          <div class="card-body">
            <h6 class="card-title text-secondary">Subject: {{ item.subject?.name || 'N/A' }}</h6>
            <p class="mb-1">Subject Price: <strong>${{ item.subject?.subject_price || 'N/A' }}</strong></p>
            <p class="mb-1">Student Level: {{ item.student_level?.level || 'N/A' }}</p>
            <p class="mb-1">Level Price: ${{ item.student_level?.st_level_price || 'N/A' }}</p>
            <hr />
            <p class="fw-bold text-success">Total Price: ${{ item.item_total_price }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="text-center mt-4">
      <button
        class="btn btn-outline-primary me-2"
        :disabled="currentPage === 1"
        @click="changePage(currentPage - 1)"
      >
        <i class="bi bi-arrow-left"></i> Prev
      </button>

      <button
        class="btn btn-outline-primary"
        :disabled="currentPage === lastPage"
        @click="changePage(currentPage + 1)"
      >
        Next <i class="bi bi-arrow-right"></i>
      </button>

      <p class="mt-2 text-muted">Page {{ currentPage }} of {{ lastPage }} (Total: {{ totalItems }})</p>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="addTecherItemModal" tabindex="-1" aria-labelledby="addTecherItemModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="addTecherItemModalLabel">Add or Update Teacher Item</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <AddPackage
            :teacher-id="teacherId"
            :teacher-user-id="teacherUserId"
            @item-saved="handleItemSaved"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import AddPackage from '@/components/Teacher/AddPackage.vue';

export default {
  props: {
    teacherId: {
      type: Number,
      required: true
    }
  },
  components: {
    AddPackage,
  },
  data() {
    return {
      teacherItems: [],
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      perPage: 2,
      teacherUserId: null, // ✅ add this
      loading: false // <-- add this
    };
  },
  mounted() {
    this.fetchTeacherItems();
    this.fetchUserIdandTeacherID(); // auto fetch on mount
  },
  methods: {
    fetchTeacherItems() {
        this.loading = true; // start loading
      axios
        .get('/get-teacher-items-detail-by-id', {
          headers: {
            'Teacher-ID': this.teacherId
          },
          params: {
            page: this.currentPage,
            per_page: this.perPage
          }
        })
        .then(response => {
          this.teacherItems = response.data.items;
          this.totalItems = response.data.total;
          this.currentPage = response.data.current_page;
          this.lastPage = response.data.last_page;
        })
        .catch(error => {
          console.error('Error fetching teacher items:', error);
        })
         .finally(() => {
        this.loading = false; // stop loading
      });
    },
    
    handleItemSaved() {
      this.fetchTeacherItems();
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchTeacherItems();
    },
    async deleteItem(itemId, index) {
      if (confirm('Are you sure you want to delete this item?')) {
        try {
          await axios.delete(`/delete-items/${itemId}`);
          this.teacherItems.splice(index, 1);
          this.fetchTeacherItems();
        } catch (error) {
          console.error('Error deleting item:', error);
        }
      }
    },
    
    
    async fetchUserIdandTeacherID() {
  try {
    const response = await axios.get('/get-user-id-by-teacher', {
      headers: {
        'Teacher-ID': this.teacherId
      }
    });

    console.log('Teacher ID:', response.data.teacher_id);
    console.log('Teacher User ID:', response.data.user_id);

    // ✅ Set teacherUserId here so it updates the prop
    this.teacherUserId = response.data.user_id;

    // Optional emit if you need to notify the parent component
    this.$emit('teacher-and-user-id-fetched', {
      teacherId: response.data.teacher_id,
      teacherUserId: response.data.user_id
    });
  } catch (error) {
    console.error('Error fetching user ID:', error);
  }
}


  }
};
</script>

<style scoped>
.card {
  border-radius: 12px;
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.1);
}

.card-title {
  font-weight: 600;
}

.item-card {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hover-transition {
  transition: all 0.3s ease;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
}
</style>
